import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Wordmark } from "@/components/Logo";
import { toast } from "sonner";

export default function Login() {
    const { login } = useAuth();
    const [email, setEmail] = useState("demo@studysphere.app");
    const [password, setPassword] = useState("Demo1234!");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const loc = useLocation();

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const res = await login(email, password);
        setLoading(false);
        if (res.ok) {
            toast.success("Welcome back");
            navigate(loc.state?.from || "/app");
        } else {
            toast.error("Login failed", { description: res.error });
        }
    };

    return (
        <div className="min-h-screen grid lg:grid-cols-2 bg-background">
            <div className="hidden lg:block relative overflow-hidden">
                <div className="absolute inset-0 bg-primary" />
                <div
                    className="absolute inset-0 opacity-40 mix-blend-overlay"
                    style={{ backgroundImage: "url(https://images.unsplash.com/photo-1564910443496-5fd2d76b47fa?crop=entropy&cs=srgb&fm=jpg&w=1200)", backgroundSize: "cover", backgroundPosition: "center" }}
                />
                <div className="absolute inset-0 grain" />
                <div className="relative h-full flex flex-col justify-between p-12 text-primary-foreground">
                    <Wordmark />
                    <div>
                        <div className="mono-label text-primary-foreground/70 mb-4">Your academic command center</div>
                        <h1 className="font-display text-4xl xl:text-5xl leading-[1.05] font-medium mb-6">Focus deeper.<br/>Learn faster.<br/>Ship your semester.</h1>
                        <p className="font-serif italic text-primary-foreground/80 max-w-md leading-relaxed">
                            The premium study workspace college students actually finish their assignments in.
                        </p>
                    </div>
                    <div className="text-xs text-primary-foreground/60">© {new Date().getFullYear()} StudySphere</div>
                </div>
            </div>

            <div className="flex items-center justify-center p-6 md:p-12">
                <form onSubmit={submit} className="w-full max-w-sm space-y-6" data-testid="login-form">
                    <div className="lg:hidden mb-2"><Wordmark /></div>
                    <div>
                        <div className="mono-label mb-2">Sign in</div>
                        <h2 className="font-display text-3xl font-medium tracking-tight">Welcome back.</h2>
                        <p className="text-sm text-muted-foreground mt-2">Enter your credentials to continue.</p>
                    </div>

                    <div className="space-y-4">
                        <div>
                            <Label htmlFor="email" className="text-xs mono-label">Email</Label>
                            <Input id="email" data-testid="email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5" />
                        </div>
                        <div>
                            <Label htmlFor="password" className="text-xs mono-label">Password</Label>
                            <Input id="password" data-testid="password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1.5" />
                        </div>
                    </div>

                    <Button type="submit" disabled={loading} className="w-full h-11" data-testid="login-submit">
                        {loading ? "Signing in…" : "Sign in"}
                    </Button>

                    <p className="text-sm text-center text-muted-foreground">
                        New to StudySphere? <Link to="/register" className="text-primary font-medium hover:underline" data-testid="go-to-register">Create an account</Link>
                    </p>
                    <p className="text-[11px] text-center text-muted-foreground/70">
                        Demo: demo@studysphere.app / Demo1234!
                    </p>
                </form>
            </div>
        </div>
    );
}
